import Divider from '@alltrails/denali/components/Divider';
import styles from './PageUIDivider.module.scss';

export default function PageUIDivider() {
  return <Divider classes={styles.divider} />;
}
